import { useLocation } from 'react-router-dom';
import { ConfirmationTemplate } from '@templates';
import { useEffect } from 'react';
import {
  resetIssueDetails,
  resetUserDetails,
  useAnimalNuisanceStore,
} from '@animal-nuisance/hooks/useAnimalNuisanceStore';
import { basename } from '@animal-nuisance/routes/basename';
import { RoutesList } from '@animal-nuisance/routes/Routes';

export const ConfirmationPage = () => {
  const {
    data: {
      wantConfirmationEmail,
      caseReferenceId,
      slaText,
      canBeContacted,
      userDetails,
    },
  } = useAnimalNuisanceStore();

  const contentTitle = `What happens next?`;
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      // Prevent default behavior and navigate to home page
      window.location.replace('https://www.westminster.gov.uk/report-it');
      resetUserDetails();
      resetIssueDetails();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  let subText1;
  let subText2;
  if (wantConfirmationEmail) {
    subText1 = <p>We have sent a confirmation email to {userDetails?.email}</p>;
    if (canBeContacted) {
      subText2 = (
        <p>We may contact you by email if we need more information.</p>
      );
    } else {
      subText2 = <p>You won’t be contacted further about the issue.</p>;
    }
  } else {
    if (canBeContacted) {
      subText2 = (
        <p>We may contact you by email if we need more information.</p>
      );
    } else {
      subText2 = (
        <p>
          As you did not leave your contact details you will not receive a
          confirmation email.
        </p>
      );
    }
  }

  const contentSubtext = (
    <div className="text-bodyLg text-text-body flex flex-col gap-6">
      {subText1}
      {subText2}
      <p className="mb-4">
        We will aim to review the issue within {slaText || '5 working days'}.
      </p>
    </div>
  );

  const navigationButton = {
    label: 'Return to homepage',
    isExternalLink: true,
    href: 'https://www.westminster.gov.uk/report-it ',
  };

  return (
    <ConfirmationTemplate
      reference={caseReferenceId}
      contentTitle={contentTitle}
      contentSubtext={contentSubtext}
      feedbackLink={true}
      button={navigationButton}
    />
  );
};
